import {
  Info as Icon // TODO: select an icon
} from 'components/icons';

export const meta = {
  id: 'DynamicModule',
  title: 'DynamicModule',
  category: 'Utils',
  // exposes: [
  //   {
  //     title: 'General',
  //     action: { module: 'DynamicModule', props: { /* */ } },
  //     desription: 'general-desc',
  //   },
  // ],
  unique: false,
  icon: Icon,
  version: '1.0.0',
  description: `A module that can be used to dynamically add contents to a window.`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
